<template>
  <div class="welcome-screen text-center">
    <div class="w-full h-full flex flex-col py-6 text-black text-center relative">
      <p v-if="error" class="error" v-html="error"></p>
      <h3 class="title mx-auto mb-5 lg:mt-20">{{ $t('stamp.welcome_steps') }}</h3>
      <div class="flex flex-1">
        <div class="grid">
          <img class="personal-items" src="../../assets/stamp/personal-items.png" />
          <div class="step">STEP 1</div>
          <p
            class="alt-info mt-4"
            v-html="isIncein ? $t('incein.welcome_step_1') : $t('stamp.welcome_step_1')"
          ></p>
        </div>
        <div class="grid">
          <img class="mobile-phone" src="../../assets/stamp/mobile-phone.png" />
          <div class="step">STEP 2</div>
          <p
            class="alt-info mt-4"
            v-html="isIncein ? $t('incein.welcome_step_2') : $t('stamp.welcome_step_2')"
          ></p>
        </div>
      </div>
      <img
        v-if="isIncein"
        class="stamp-icon"
        src="../../assets/stamp/incein-logo.png"
        alt="Incein"
      />
      <img v-else class="stamp-icon" src="../../assets/stamp/app-icon.png" alt="Stamp" />
    </div>
  </div>
</template>

<script>
import incein from '@/mixins/incein';
import audioPlayer from '@/mixins/audio-player';

export default {
  name: 'Welcome',
  mixins: [audioPlayer, incein],
  props: {
    error: String,
    mute: Boolean,
  },
  mounted() {
    this.play();
  },
  beforeDestroy() {
    this.stopAudio();
    this.clearTimer();
  },
  methods: {
    play() {
      this.clearTimer();
      if (!this.mute) {
        this.playAudio('Voice1')
          .then(wasStopped => {
            if (!wasStopped) {
              this.repeat();
            }
          })
          .catch(() => {});
      }
    },
    repeat() {
      this.timer = setTimeout(this.play, 15000);
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
  },
  watch: {
    mute(nv) {
      if (nv) {
        this.clearTimer();
        this.stopAudio();
      } else if (!nv) {
        this.play();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-screen {
  @apply relative flex flex-col items-center;
  height: 100%;
  padding: 30px 50px 10px;
}
.title {
  max-width: 475px;
  font-size: 24px;
  color: #fff;
}
.grid {
  @apply flex flex-col flex-1 mx-2 px-5;
  background: white;
  max-height: 410px;
  img {
    @apply mx-auto mt-12;
    height: 150px;
    width: auto;
  }
  @screen lg {
    img {
      height: 200px;
    }
    @apply mt-auto mb-10;
    min-height: 550px;
  }
}
.step {
  @apply px-4 py-2 mx-auto mt-3;
  max-width: 100px;
  font-size: 18px;
  border-bottom: 3px solid black;
  @screen lg {
    @apply mt-10;
    max-width: 200px;
    font-size: 20px;
  }
}
.alt-info {
  font-size: 20px;
  text-align: left;
  @screen lg {
    @apply mt-10;
    font-size: 24px;
  }
}
.error {
  @apply absolute w-full;
  top: -10px;
  font-size: 20px;
  color: red;
}
.stamp-icon {
  @apply mx-auto mt-10;
  max-width: 80px;
}
</style>
